import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { SemanticUI } from '@iterable/deprecated_react_components';

const headerCellStyles = `
  background: none;
  color: #717171;
  width: 100%;
  padding: ${pxToRem(5)} ${pxToRem(8)};
  white-space: nowrap;
  border: ${pxToRem(1)} solid transparent;
  border-left: 0;
  border-right: 0;
  > .sort {
    display: inline;
    margin-left: ${pxToRem(5)};
    line-height: 1;
    color: #c3c3c5;
  }
  .main[data-active-sort='true'] > &,
  .main:hover > & {
    > .sort {
      color: #717171;
    }
  }
  .main[data-actions='true'] > & {
    display: flex;
  }
`;

export const HeaderCell = styled.div`
  ${headerCellStyles}
`;

export const HeaderCellButton = styled.button`
  font-weight: 400;
  ${headerCellStyles}
`;

export const StyledSemanticCheckbox = styled(SemanticUI.Checkbox)`
  &&& {
    margin: 0;
    ${headerCellStyles}
    padding-bottom: 0;
  }
`;

export const HeaderCellContainer = styled.div`
  display: table-cell;
  border: none;
  flex: 1 1 100%;
  font-weight: 600;
  max-width: 100%;
  padding: 0;
  vertical-align: top;
  &:hover > ${HeaderCellButton} {
    color: #2e8ece;
  }
  &:not([data-checkbox='true']) {
    min-width: ${pxToRem(20)};
  }
  &[data-checkbox='true'] {
    min-width: ${pxToRem(40)};
    width: ${pxToRem(40)};
  }
  &[data-docked='true'] {
    position: sticky;
    left: 0;
    top: 0;
    border-right: ${pxToRem(1)} solid #999999;
  }
  &[data-shrink='true'] {
    flex-shrink: 3;
  }
`;
